// src/components/Unsubscribe.jsx
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unsubscribeEmail, resetStatus } from '../redux/features/subscriptionSlice';

const Unsubscribe = () => {
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const { unsubscribeStatus, error } = useSelector(state => state.subscription);

    useEffect(() => {
        return () => {
            dispatch(resetStatus());
        };
    }, [dispatch]);

    const handleUnsubscribe = async (e) => {
        e.preventDefault();
        dispatch(unsubscribeEmail(email));
    };

    // Reset form on successful unsubscribe
    useEffect(() => {
        if (unsubscribeStatus === 'succeeded') {
            setEmail('');
            // Optional: Reset status after a delay
            const timer = setTimeout(() => {
                dispatch(resetStatus());
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [unsubscribeStatus, dispatch]);

    return (
        <div className="max-w-md mx-auto mt-12 p-6 bg-white rounded-lg shadow-md">
            <h1 className="text-2xl font-bold mb-4">Unsubscribe from Newsletter</h1>
            <form onSubmit={handleUnsubscribe} className="space-y-4">
                <div>
                    <label htmlFor="email" className="block text-gray-700 mb-2">
                        Email Address
                    </label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-4 py-2 border rounded-md"
                        required
                    />
                </div>

                <button
                    type="submit"
                    disabled={unsubscribeStatus === 'loading'}
                    className="w-full py-2 px-4 bg-red-600 text-white rounded-md hover:bg-red-700"
                >
                    {unsubscribeStatus === 'loading' ? 'Processing...' : 'Unsubscribe'}
                </button>

                {unsubscribeStatus === 'succeeded' && (
                    <p className="text-green-600">
                        You have been successfully unsubscribed.
                    </p>
                )}

                {unsubscribeStatus === 'failed' && (
                    <p className="text-red-600">{error}</p>
                )}
            </form>
        </div>
    );
};

export default Unsubscribe;
